import { type ActionCreator, createActionCreator, createGenericActionCreator } from '@pressreader/appstore';
import type { AnyPopup, PopupContentType, PopupType } from '@pressreader/popups-types';

import { MODULE_NAME } from '../constants';

const prefix = MODULE_NAME + '/';

interface IPopupOpenedPayload<TPopup extends AnyPopup> {
    popup: TPopup;
}

interface IPopupChangedPayload {
    popup: AnyPopup;
}

interface IClosePopupPayload<TResult> {
    id: string;

    isBack?: boolean;
    isCancelled?: boolean;

    result?: TResult;
}

interface IPopupClosedPayload<TResult> {
    id: string;

    /**
     * kind of the closed popup, so listeners can tell a non-modal (floating) close from a blocking one
     */
    type: PopupType;

    /**
     * popup name
     */
    content: PopupContentType | null;

    isCancelled?: boolean;

    result?: TResult;
}

type popupOpened<TPopup extends AnyPopup> = ActionCreator<IPopupOpenedPayload<TPopup>>;
const popupOpened = createGenericActionCreator<IPopupOpenedPayload<AnyPopup>>(`${prefix}popup_opened`);

const popupChanged = createActionCreator<IPopupChangedPayload>(`${prefix}popup_options_changed`);

type closePopupAction<TResult> = ActionCreator<IClosePopupPayload<TResult>>;
const closePopupAction = createGenericActionCreator<IClosePopupPayload<unknown>>(`${prefix}close_popup`);

const popupClosed = createGenericActionCreator<IPopupClosedPayload<unknown>>(`${prefix}popup_closed`);

const baselinePopupOpened = createActionCreator<{ id: string; type: AnyPopup['type'] }>(`${prefix}baseline_popup_opened`);
const baselinePopupClosed = createActionCreator<{ id: string }>(`${prefix}baseline_popup_closed`);

const POPUP_VISIBILITY_CHANGE_ACTIONS = Object.freeze([popupOpened, popupClosed, baselinePopupOpened, baselinePopupClosed]);

export { baselinePopupClosed, baselinePopupOpened, closePopupAction, POPUP_VISIBILITY_CHANGE_ACTIONS, popupChanged, popupClosed, popupOpened };
